import { Box, IconButton } from "@mui/material";
import { Icon } from "@iconify/react";
import moment from "moment";
export const HeaderConfig = (userDetails) => {
  const result = [
    {
      label: "Engine Serial Number",
      id: "engineSerialNumber",
    },
    {
      label: "Nature Of Complaint",
      id: "natureOfComplaint",
    },
    {
      label: "Defect",
      id: "defect",
    },
    {
      label: "OEM",
      id: "oem",
      render: (data) => {
        const oemNames = data?.oem?.map((ele) => ele.name);
        return (
          <Box sx={{ maxWidth: "400px", wordBreak: "break-all" }}>
            {oemNames?.join(", ")}
          </Box>
        );
      },
    },
    {
      label: "Engine Model",
      id: "engineModel",
      render: (data) => (
        <Box sx={{ maxWidth: "400px", wordBreak: "break-all" }}>
          {data?.engineModel?.join(", ")}
        </Box>
      ),
    },
    {
      label: "List Numbers",
      id: "listNo",
      render: (data) => (
        <Box sx={{ maxWidth: "400px", wordBreak: "break-all" }}>
          {data?.listNo?.join(", ")}
        </Box>
      ),
    },
    { label: "Cut-in Esn", id: "cutInEsn" },

    {
      label: "Cut-in Effective Date",
      id: "cutInEffectiveDate",
      render: (data) => (
        <span>
          {data.cutInEffectiveDate &&
            moment(data.cutInEffectiveDate).format("DD/MM/YYYY")}
        </span>
      ),
    },
    {
      label: "Action",
      id: "action",
      render: (data, onClick) => (
        <Box sx={{ display: "flex" }}>
          <IconButton onClick={() => onClick("VIEW", data)}>
            <Icon
              icon="carbon:task-view"
              width="2rem"
              height="2rem"
              style={{ color: "#093986" }}
            />
          </IconButton>
        </Box>
      ),
    },
  ];

  return result;
};
export const FailedPartsHeaderConfig = (userDetails) => {
  const result = [
    {
      label: "Part Number",
      id: "partNumber",
    },
    {
      label: "Description",
      id: "description",
    },
    {
      label: "Nature of complaint",
      id: "natureOfComplaint",
    },
    {
      label: "Defect",
      id: "defect",
    },
    {
      label: "OEM",
      id: "oem",
      render: (data) => {
        const oemNames = data?.oem?.map((ele) => ele.name);
        return (
          <Box sx={{ maxWidth: "400px", wordBreak: "break-all" }}>
            {oemNames?.join(", ")}
          </Box>
        );
      },
    },
    {
      label: "Engine Model",
      id: "engineModel",
      render: (data) => (
        <Box sx={{ maxWidth: "400px", wordBreak: "break-all" }}>
          {data?.engineModel?.join(", ")}
        </Box>
      ),
    },
    {
      label: "List Numbers",
      id: "listNo",
      render: (data) => (
        <Box sx={{ maxWidth: "400px", wordBreak: "break-all" }}>
          {data?.listNo?.join(", ")}
        </Box>
      ),
    },
    { label: "Cut-in Esn", id: "cutInEsn" },

    {
      label: "Cut-in Effective Date",
      id: "cutInEffectiveDate",
      render: (data) => (
        <span>
          {data.cutInEffectiveDate &&
            moment(data.cutInEffectiveDate).format("DD/MM/YYYY")}
        </span>
      ),
    },
    {
      label: "Action",
      id: "action",
      render: (data, onClick) => (
        <Box sx={{ display: "flex" }}>
          <IconButton onClick={() => onClick("VIEW", data)}>
            <Icon
              icon="carbon:task-view"
              width="2rem"
              height="2rem"
              style={{ color: "#093986" }}
            />
          </IconButton>
        </Box>
      ),
    },
  ];

  return result;
};
